export default __webpack_public_path__ + "assets/webgl/complete-11.a5ab399b.jpg";